export const APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
export const SCOPE =
  "pages_manage_metadata, pages_show_list, instagram_basic, instagram_manage_messages, pages_messaging";
